import { useCallback, useMemo, useSyncExternalStore } from 'react';
import { APPEARANCE_CHANGED, parseAppearanceSnapshot, readAppearanceSnapshot } from '@/services/appearancePreferences';
import { getStorageKey } from '@/services/userSettingsStore';

export function useAppearancePreferences(userId: string) {
  const subscribe = useCallback((notify: () => void) => {
    const changed = (event: Event) => {
      if ((event as CustomEvent<{ userId: string }>).detail?.userId === userId) notify();
    };
    const storage = (event: StorageEvent) => { if (event.key === null || event.key === getStorageKey(userId)) notify(); };
    window.addEventListener(APPEARANCE_CHANGED, changed);
    window.addEventListener('storage', storage);
    return () => { window.removeEventListener(APPEARANCE_CHANGED, changed); window.removeEventListener('storage', storage); };
  }, [userId]);
  const getSnapshot = useCallback(() => readAppearanceSnapshot(userId), [userId]);
  const raw = useSyncExternalStore(subscribe, getSnapshot, () => null);
  return useMemo(() => ({ ...parseAppearanceSnapshot(raw), raw }), [raw]);
}
